// extracted by mini-css-extract-plugin
module.exports = {"postCover":"post-image-module--post-cover--3IUmE","postImageContainer":"post-image-module--post-image-container--2JEAW"};